export const customerSupportEmail = 'customer-success@risksmart.com';
